import { inject, Injectable, Injector, TransferState } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpEvent,
    HttpRequest,
    HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { LocaleService } from '@finder/shared/services/locale-service/locale-service.service';
import { LOCALE, LOCALE_DEFAULT, SSR_LOCALE } from '@finder/shared/constants/app.constants';

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
    private ssrLocale = inject(LOCALE, { optional: true });

    constructor(
        private injector: Injector,
        private transferState: TransferState,
    ) { }

    /**
     * Add the locale to every request
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const localeService = this.injector.get(LocaleService);
        // Get locale from cookie, and if it's not defined, use the default
        const locale = localeService.getLocale() || this.ssrLocale || LOCALE_DEFAULT;

        req = req.clone({
            setHeaders: {
                'Accept-Language': locale
            }
        });

        // @SSR: Store the locale if we have it
        if (this.ssrLocale) {
            this.transferState.set(SSR_LOCALE, this.ssrLocale);
        }

        return next.handle(req);
    }
}
